import useAlias from '@alias';
import { TextField } from '@mui/material';
import { AddUserFormValues } from '@src/hooks/api/mutations/useUserCreate';
import { EditUserFormValues } from '@src/hooks/api/mutations/useUserUpdate';
import { useFormContext } from 'react-hook-form';

function LastNameField() {
  const alias = useAlias();
  const { register } = useFormContext<EditUserFormValues | AddUserFormValues>();

  return (
    <TextField
      fullWidth
      label={alias('Last Name')}
      {...register('lastName')}
      size='small'
    />
  );
}

export default LastNameField;
